<template>
  <div>
    <Tabs :animated="false">
      <TabPane label="胜任力评估">
        <ComChart></ComChart>
        <ComTable></ComTable>
      </TabPane>
    </Tabs>
  </div>
</template>

<script>
import ComChart from "@/components/bipage/components/ComChart";
import ComTable from "@/components/bipage/components/ComTable";
export default {
  components: {
    ComChart,
    ComTable
  },
  data() {
    return {};
  }
};
</script>



// WEBPACK FOOTER //
// src/components/bipage/CompetencyAssessment.vue